// @ts-nocheck
import { getCookie, removeCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import union from "lodash/union";

const storageKey = "ProductListMap";
type StorageEntry = string[];
type StorageData = Dictionary<StorageEntry>;

export const addListToProductStorage = (listId: string, productIds: string[]) => {
    try {
        const data: StorageData = JSON.parse(getCookie(storageKey) || "{}");

        productIds.forEach(productId => {
            if (data[productId]?.includes(listId)) {
                return;
            }

            data[productId] = [...(data[productId] || []), listId];
        });

        setCookie(storageKey, JSON.stringify(data));
    } catch (error) {} // eslint-disable-line
};

export const removeListFromProductStorage = (listId: string, productIds: string[]) => {
    try {
        const data: StorageData = JSON.parse(getCookie(storageKey) || "{}");

        productIds.forEach(productId => {
            if (!data[productId]) {
                return;
            }

            data[productId] = data[productId].reduce((result, iterationListId) => {
                if (iterationListId === listId) {
                    return result;
                }

                return [...result, iterationListId];
            }, [] as StorageEntry);

            if (!data[productId].length) {
                delete data[productId];
            }
        });

        if (Object.keys(data).length) {
            setCookie(storageKey, JSON.stringify(data));
        } else {
            removeCookie(storageKey);
        }
    } catch (error) {} // eslint-disable-line
};

export const getCompleteProductListIds = (product: ProductModel | undefined | null) => {
    if (!product) {
        return [];
    }

    let productListIds: string[] = product.properties.containedInLists?.split(",") || [];

    if (!product.id) {
        return productListIds;
    }

    try {
        const data: StorageData = JSON.parse(getCookie(storageKey) || "{}");
        productListIds = union(productListIds, data[product.id]);
    } catch (error) {} // eslint-disable-line

    return productListIds;
};

export const getProductIsInList = (product: ProductModel | undefined | null, listId?: string) => {
    const productListIds = getCompleteProductListIds(product);

    return listId ? productListIds.includes(listId) : productListIds.length > 0;
};
